import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import CloseOutlined from "@ant-design/icons/es/icons/CloseOutlined";
import React from 'react';
import Button from '../button';
import { convertLegacyProps } from '../button/button';
import { useLocale } from '../locale';
import { getConfirmLocale } from './locale';
export function renderCloseIcon(prefixCls, closeIcon) {
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-close-x")
  }, closeIcon || /*#__PURE__*/React.createElement(CloseOutlined, {
    className: "".concat(prefixCls, "-close-icon")
  }));
}
export var Footer = function Footer(props) {
  var okText = props.okText,
      _props$okType = props.okType,
      okType = _props$okType === void 0 ? 'primary' : _props$okType,
      cancelText = props.cancelText,
      confirmLoading = props.confirmLoading,
      onOk = props.onOk,
      onCancel = props.onCancel,
      okButtonProps = props.okButtonProps,
      cancelButtonProps = props.cancelButtonProps;

  var _useLocale = useLocale('Modal', getConfirmLocale()),
      _useLocale2 = _slicedToArray(_useLocale, 1),
      locale = _useLocale2[0];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText)), /*#__PURE__*/React.createElement(Button, Object.assign({}, convertLegacyProps(okType), {
    loading: confirmLoading,
    onClick: onOk
  }, okButtonProps), okText || (locale === null || locale === void 0 ? void 0 : locale.okText)));
};